import { render } from "./BodyFontPicker.vue?vue&type=template&id=8ddcac14"
import script from "./BodyFontPicker.vue?vue&type=script&lang=js"
export * from "./BodyFontPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__